<div> {{ name }} </div>
<div class="pt-2"><i> {{ products }} </i></div>
